import ApiBase from '../api-base'
import { ACTIVE_BASE_REST } from '../constants'

export default class OrderBatch extends ApiBase {
  constructor(store) {
    super(store, `${ACTIVE_BASE_REST}/order/batch`)
  }

  updateFurnitureOrigin(id, model, showProgress) {
    return this._request({
      action: `${id}/origin/furniture`,
      body: model,
      method: 'PUT',
      showProgress
    })
  }

  updateCargoOrigin(id, model, showProgress) {
    return this._request({
      action: `${id}/origin/cargo`,
      body: model,
      method: 'PUT',
      showProgress
    })
  }

  updateFreightOrigin(id, model, showProgress) {
    return this._request({
      action: `${id}/origin/freight`,
      body: model,
      method: 'PUT',
      showProgress
    })
  }

  createFurniture(model, showProgress) {
    return this._request({
      action: `furniture/create`,
      body: model,
      method: 'POST',
      showProgress
    })
  }

  createCargo(model, showProgress) {
    return this._request({
      action: `cargo/create`,
      body: model,
      method: 'POST',
      showProgress
    })
  }

  createFreight(model, showProgress) {
    return this._request({
      action: `freight/create`,
      body: model,
      method: 'POST',
      showProgress
    })
  }
}
